import React from 'react';
import {
    MemberItem as StyledMemberItem,
    MemberInfo,
    Avatar,
    UserDetails,
    UserName,
    UserEmail,
    Actions,
    RoleSelect,
    RemoveButton
} from '../../styles/ProjectMembers.styles';

const MemberItem = ({
    userId,
    memberData,
    userData,
    currentUserRole,
    isCurrentUser,
    onRoleChange,
    onRemove
}) => (
    <StyledMemberItem>
        <MemberInfo>
            <Avatar src={userData.photoURL}>
                {!userData.photoURL && (userData.displayName?.[0] || userData.email?.[0])}
            </Avatar>
            <UserDetails>
                <UserName>{userData.displayName || userData.email}</UserName>
                <UserEmail>{userData.email}</UserEmail>
            </UserDetails>
        </MemberInfo>
        <Actions>
            <RoleSelect
                value={memberData.role}
                onChange={(e) => onRoleChange(userId, e.target.value)}
                disabled={currentUserRole !== 'admin' || isCurrentUser}
            >
                <option value="admin">Admin</option>
                <option value="collaborator">User</option>
            </RoleSelect>
            {currentUserRole === 'admin' && !isCurrentUser && (
                <RemoveButton
                    onClick={() => onRemove(userId)}
                    title="Remove member"
                >
                    ×
                </RemoveButton>
            )}
        </Actions>
    </StyledMemberItem>
);

export default MemberItem;